import React from "react";
import PropTypes from "prop-types";
import check from "assets/images/checklist.jpg";

const OnboardingTasks = ({ formData, handleCheckboxChange, isCompleted }) => {


  return (
    <>
      <label className="mb-3" style={{ textAlign: "left", fontSize: "large", color: "#3dc00f" }}>
        <img
          src={check}
          height={"35px"}
          style={{ marginLeft: "-8px" }}
          alt="Tasks for HR Administrator"
        />
        Tasks for HR Administrator
      </label>
      {[
        {
          key: "welcomeEmail",
          message: "Share the good news! Send a welcome email introducing your new hire.",
        },
        {
          key: "mentorAssignment",
          message: "Assign your new hire a mentor and/or onboarding buddy.",
        },
        {
          key: "recurringOneOnOneMeetings",
          message:
            "Invite your new employee to recurring one-on-one meetings to provide regular check-ins.",
        },
        {
          key: "firstDayMeetings",
          message:
            "Schedule your new hire’s first day meetings, prioritizing intro calls with colleagues who will work closely with the new hire.",
        },
        {
          key: "welcomeMeeting",
          message:
            "Coordinate a welcome meeting or phone call to kick off your new hire’s first day.",
        },
        {
          key: "welcomeLunch",
          message: "Set up a welcome lunch with the new hire’s team, if appropriate.",
        },
        {
          key: "businessIntroduction",
          message:
            "Give the new employee an introduction to the business, including how their role fits in and any performance expectations you’ll have for their onboarding.",
        },
        { key: "officeTour", message: "Take your new hire on a tour of the office." },
      ].map(({ key, message }, index) => (
        <div className="form-check OnboardCheckbox" key={index}>
          <input
            className="form-check-input"
            type="checkbox"
            checked={!!formData[key]}
            id={`Check${index + 1}`}
            disabled={isCompleted} 
            onChange={() => handleCheckboxChange(key)}
          />
          <label className="form-check-label" htmlFor={`Check${index + 1}`}>
            {message}
          </label>
        </div>
      ))}
      <label className="mb-3" style={{ textAlign: "left", fontSize: "large", color: "#3dc00f" }}>
        <img src={check} height={"35px"} style={{ marginLeft: "-8px" }} alt="check" />
        Mentor or Onboarding Buddy Checklist
      </label>

      {[
        {
          key: "regularCheckIns",
          text: "Schedule regular check-ins throughout the first two weeks.",
        },
        {
          key: "shadowingOpportunities",
          text: "Invite new hires to shadow relevant meetings or projects.",
        },
        { key: "adHocSupport", text: "Be responsive to ad hoc questions throughout the day!" },
      ].map(({ key, text }, index) => (
        <div className="form-check OnboardCheckbox" key={index}>
          <input
            className="form-check-input"
            type="checkbox"
            checked={!!formData[key]}
            id={`Check${index + 18}`}
            onChange={() => handleCheckboxChange(key)}
          />
          <label className="form-check-label" htmlFor={`Check${index + 18}`}>
            {text}
          </label>
        </div>
      ))}
      <label className="mb-3" style={{ textAlign: "left", fontSize: "large", color: "#3dc00f" }}>
        <img src={check} height={"35px"} style={{ marginLeft: "-8px" }} alt="check" />
        Required Onboarding Documents for New Hires
      </label>

      {[
        { key: "benefitsEnrollment", text: "Benefits enrollment paperwork" },
        { key: "emergencyContactInfo", text: "Emergency contact information" },
        { key: "employeeHandbook", text: "Employee handbook featuring all company policies" },
        { key: "directDepositInfo", text: "Direct deposit and payroll information" },
        {
          key: "employmentEligibilityForm",
          text: "i-9 form (employment eligibility verification)",
        },
        {
          key: "ndaOrNonCompete",
          text: "non-disclosure agreement, non-compete, or confidentiality agreement (if applicable)",
        },
        { key: "stateTaxWithholdingForm", text: "State tax withholding form (varies by location)" },
        {
          key: "federalTaxWithholdingForm",
          text: "w-4 form (employee`s withholding certificate for federal taxes) or W-9 for contractors",
        },
      ].map(({ key, text }, index) => (
        <div className="form-check OnboardCheckbox" key={index}>
          <input
            className="form-check-input"
            type="checkbox"
            checked={!!formData[key]}
                       id={`Check${index + 30}`}
            onChange={() => handleCheckboxChange(key)}
          />
          <label className="form-check-label" htmlFor={`Check${index + 30}`}>
            {text}
          </label>
        </div>
      ))}
    </>
  );
};

OnboardingTasks.propTypes = {
  formData: PropTypes.object.isRequired,
  handleCheckboxChange: PropTypes.func.isRequired,
  isCompleted: PropTypes.bool.isRequired,
};

export default OnboardingTasks;
